import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  FLAT_FORM_FIELD_NAME_FLAT_NUMBER,
  FLAT_FORM_FLAT_NUMBER_FIELD_MAX_LENGTH,
} from '../../FlatForm.constants'

function FlatNumberField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Flat.NumberLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={FLAT_FORM_FLAT_NUMBER_FIELD_MAX_LENGTH}
      name={FLAT_FORM_FIELD_NAME_FLAT_NUMBER}
      placeholder={t('Flat.NumberPlaceholderKey')}
    />
  )
}

export default FlatNumberField
